import React, { useState } from "react";
import { Col } from "react-bootstrap";
import "../../Assets/Styles/pages/nav.scss";
import computer from "../../Assets/Images/computer_nav.svg";
import sign from "../../Assets/Images/sign_nav.svg";
import text from "../../Assets/Images/text_nav.svg";
import stick from "../../Assets/Images/stick_nav.svg";
import date from "../../Assets/Images/date_nav.svg";
import temp from "../../Assets/Images/temp_nav.svg";
import UploadImage from "../UploadImage/uploadImage";
import SignIn from "../SignIn/signIn";
import NavObject from "./navObjects";

const Nav = ({
  setHidden,
  setOpenDate,
  setOpenText,
  setOpenSignature,
  hidden,
  active,
  setActive,
  deselect,
  userSliceState,
}) => {
  const [openSignIn, setOpenSignIn] = useState(false);
  const [select, setSelect] = useState("");
  const [open, setOpen] = useState(false);

  const NavObjects = [
    {
      object: "computer",
      setOpen: setOpen,
      setObject: "",
      text: "Nav.Computer",
      src: computer,
    },
    {
      object: "signature",
      // onclick: NavigateObject("signature", setOpenSignature, ""),
      setOpen: setOpenSignature,
      setObject: "",
      text: "Nav.Signature",
      src: sign,
    },
    {
      object: "text",
      // onclick: NavigateObject("text", setOpenText, ""),
      setOpen: setOpenText,
      setObject: "",
      text: "Nav.Text",
      src: text,
    },
    {
      object: "sticker",
      // onclick: NavigateObject("sticker", setOpenText, "sticker"),
      setOpen: setSelect,
      setObject: "sticker",
      text: "Nav.Sticker",
      src: stick,
      select,
    },
    {
      object: "date",
      // onclick: NavigateObject("date", setOpenDate, ""),
      setOpen: setOpenDate,
      setObject: "",
      text: "Nav.Date",
      src: date,
    },
    {
      object: "template",
      // onclick: NavigateObject("date", null, ""),
      setOpen: setSelect,
      setObject: "template",
      text: "Nav.Templates",
      src: temp,
      condition: true,
    },
  ];

  const handleClean = () => {
    setOpen(false);
  };
  return (
    <Col
      onClick={deselect}
      className="side_nav text_12 Aktiv align-items-center"
    >
      {NavObjects?.map((item, index) => {
        return (
          <NavObject
            key={index}
            active={active}
            object={item.object}
            text={item.text}
            src={item.src}
            setObject={item.setObject}
            setOpen={item.setOpen}
            setHidden={setHidden}
            setActive={setActive}
            setOpenSignIn={setOpenSignIn}
            userSliceState={userSliceState}
            hidden={hidden}
            condition={item.condition}
            // src={ }
          />
        );
      })}
      {/* object, objectNext, active, onclick, text, style, src, parrentStyle */}

      <UploadImage
        open={open}
        setActive={setActive}
        setOpen={setOpen}
        handleClean={handleClean}
        choice={0}
        parent={false}
      />
      <SignIn open={openSignIn} setOpen={setOpenSignIn} setActive={setActive} />
    </Col>
  );
};

export default Nav;
